
import InvoicesTransactionHistoryItem from "../invoices/invoices-transaction-history-item.vue";
import ResponsiveDialog from "../../components/dialogs/responsive-dialog.vue";
import InvoicesTransactionHistoryContent from "../invoices/invoices-transaction-history-content.vue";
export default {
  components: {
    InvoicesTransactionHistoryItem,
    ResponsiveDialog,
    InvoicesTransactionHistoryContent
  },
  props: {
    dialog: {
      default: false
    },

    transactionHistoryData: {
      default: [],
      type: Array
    }
  },
  data() {
    return {};
  }
};
